import { Popover, Portal, Separator, VStack } from '@chakra-ui/react';

import { Flex } from 'shared';

import {
  JournalFilterAnchor,
  JournalFilterBySprint,
  JournalFilterHeader,
  JournalSprintFilterProvider,
  JournalChallengeFilterProvider,
  JournalFilterByChallenge,
  JournalFilterReplies,
  JournalFilterUnread,
  useJournalContext,
  useJournalFilterContext,
} from 'features/journal';
import { useIsCoachMode } from 'features/user/hooks/useIsCoachMode';

export const JournalFilter = () => {
  const isUserCoach = useIsCoachMode();
  const { noNotes } = useJournalContext();

  const { isFilterApplied } = useJournalFilterContext();

  const shouldRenderFilter = !noNotes || isFilterApplied;

  return shouldRenderFilter ? (
    <Popover.Root
      positioning={{
        placement: 'bottom-start',
      }}
    >
      <JournalFilterAnchor />
      <Portal>
        <Popover.Positioner>
          <Popover.Content width="22rem" overflow="scroll" maxH="636px">
            <Popover.Body px="0" py="0.5rem">
              <JournalFilterHeader />
              <Separator mb="0.75rem" mt="0.25rem" />
              <VStack alignItems="flex-start" gap="8px" px="1rem">
                <Flex gap="8px">
                  {isUserCoach && (
                    <>
                      <JournalFilterReplies />
                      <JournalFilterUnread />
                    </>
                  )}
                </Flex>
                <JournalChallengeFilterProvider>
                  <JournalFilterByChallenge />
                </JournalChallengeFilterProvider>
                <JournalSprintFilterProvider>
                  <JournalFilterBySprint />
                </JournalSprintFilterProvider>
              </VStack>
            </Popover.Body>
          </Popover.Content>
        </Popover.Positioner>
      </Portal>
    </Popover.Root>
  ) : null;
};
